import { Exception } from '@core/exceptions/exception';

export class PasswordTokenExpiredException extends Exception {
  constructor(message = 'Token expired.') {
    super(message);
  }
}
